export default "__VITE_ASSET__By8rPel7__"